import React, { useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import _ from "lodash";
import { IconButton } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import EditIcon from "@material-ui/icons/Edit";
import ShareIcon from "@material-ui/icons/Share";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import { getFavoriteMeals, deleteFavoriteMeal } from "../../../../../api";
import { AuthContext } from "../../../../../auth-context";
import Button from "../../../../../components/button";
import Modal from "../../../../../components/modal";
import { DashboardContext } from "../../../dashboard-context";
import { MealListItem } from "./meal-list-item";
import {copyFavoriteMeal} from "../../../../../api"

const Container = styled.div`
  margin: 0 auto 64px auto;
`;

const Title = styled.h2`
  display: flex;
  align-items: center;
  margin: 10px auto 10px auto;
  padding-bottom: 8px;
  color: #181818;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 600;

  button {
    margin-left: 16px;
  }
`;

const AddButton = styled(Button)`
  margin: 0;
  margin-right: 16px;
  min-width: 180px;
`;

const RemoveText = styled.h4`
  color: #555;
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
`;

const MealsTable = (props) => {
  const { openSnackbar } = useContext(DashboardContext);
  const { user } = useContext(AuthContext);
  const [showDeleteModal, updateShowDeleteModal] = useState(false);
  const [meals, updateMeals] = useState(null);
  const [mealsStatus, updateMealsStatus] = useState(0);
  const [mealID, updateMealID] = useState(null);
  const [mealName, updateMealName] = useState("");
  const [deleting, updateDeleting] = useState(false);

  useEffect(() => {
    if (mealsStatus === 0) {
      updateMealsStatus(1);
      getFavoriteMeals(user.id).then((res) => {
        updateMeals(res.data.meals);
        updateMealsStatus(2);
      });
    }
  }, [mealsStatus, user.id]);

  const handleAddTemplateMeal = () => {
    props.history.push("/dashboard/template/meal-edit/0");
  };

  const handleEdit = (id) => {
    props.history.push("/dashboard/template/meal-edit/" + id);
  };

  const handleCopy = (mealID) => {
    copyFavoriteMeal(user.id, mealID)
      .then((res) => {
        updateMealsStatus(0)
        openSnackbar("Meal template successfully copied", false);
      })
      .catch((err) => {
        if(err?.response?.data?.error) {
          openSnackbar(err.response.data.error, true);
        } else {
          openSnackbar("Error copying meal template", true);
        }
      });
  }

  const handleShare = (id) => {
    props.history.push("/dashboard/template/meal-share/" + id);
  };

  const handleDeleteIcon = (meal) => {
    updateMealID(meal.id);
    updateMealName(meal.name);
    updateShowDeleteModal(true);
  };

  const handleDelete = () => {
    updateDeleting(true);

    deleteFavoriteMeal(user.id, mealID)
      .then((res) => {
        let newMeals = meals.slice(0);
        _.remove(newMeals, (meal) => {
          return meal.id === mealID;
        });

        setTimeout(() => {
          updateDeleting(false);
          updateMeals(newMeals);
          updateShowDeleteModal(false);
          openSnackbar("Meal template successfully deleted", false);
        }, 700);
      })
      .catch((err) => {
        updateDeleting(false);
        updateShowDeleteModal(false);
        openSnackbar("Error deleting meal template", true);
      });
  };

  const renderView = () => {
    if (mealsStatus !== 2) {
      return <CircularProgress size={32} />;
    } else if (meals.length === 0) {
      return (
        <p>You have no day templates yet. Click "Add Day Template" below.</p>
      );
    } else {
      return meals.map((entry) => (
        <MealListItem
          key={entry.id}
          meal={entry}    
          edit={handleEdit}
          copy={() => handleCopy(entry.id)}   
          share={handleShare}
          remove={handleDeleteIcon}
        />
      ));
    }
  };

  return (
    <Container>
      <Title>
        Meal Templates
        <AddButton label="Add Meal Template" onClick={handleAddTemplateMeal} />
      </Title>
      {renderView()}
      <Modal
        title={`Delete Meal Template`}
        message={`Are you sure you want to delete this meal template?`}
        submitLabel="Delete"
        open={showDeleteModal}
        onClose={() => updateShowDeleteModal(false)}
        handleSubmit={handleDelete}
        warning
        disabled={deleting}
        isLoading={deleting}
      >
        <RemoveText>{mealName}</RemoveText>
      </Modal>
    </Container>
  );
};

export default withRouter(MealsTable);
